module.exports = __webpack_public_path__ + "static/media/london_hornsoffa_djup_tyg_alis_320_detalj_2023_1.94805ec4.jpg";